<template>
  <b-modal
    id="expired-trial"
    ref="expired-trial"
    size="expired-trial"
    centered
    hide-footer
    hide-header
    @hide="onModalClose"
  >
    <div class="modal-head">
      <i class="trial-expired-icon" />
      <h2 v-if="trialExpired" class="modal-title">
        {{ label.get("your_free_trial_has_expired") }}
      </h2>
      <h2 v-if="subscriptionExpired" class="modal-title">
        {{ label.get("your_subscription_has_expired") }}
      </h2>
    </div>
    <div class="content-wrapper">
      <p v-if="trialExpired">
        {{ label.get("expired_trial_description") }}
      </p>
      <p
        v-if="subscriptionExpired"
        v-html="label.get('expired_trial_reactivate_plan_description')"
      />
    </div>
    <div class="modal-footer">
      <a
        v-if="trialExpired"
        href="https://dashboard.attotime.com/subscription/plans"
        class="atto-btn submit subscribe"
        >{{ label.get("subscribe_now") }}</a
      >
      <a
        v-if="subscriptionExpired"
        href="https://dashboard.attotime.com/subscription/plans"
        class="atto-btn submit subscribe re"
        >{{ label.get("reactivate_subscription") }}</a
      >
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ExpiredTrialComponent",
  data() {
    return {
      subscriptionExpired:
        !this.$store.state.onTrial &&
        !this.$store.state.subscribed &&
        !this.$store.state.company.trial_ends_at,
      trialExpired:
        !this.$store.state.onTrial &&
        !this.$store.state.subscribed &&
        this.$store.state.company.trial_ends_at,
    };
  },
  mounted() {
    this.$refs["expired-trial"].show();
  },
  methods: {
    onModalClose() {
      this.$root.$emit("noSubscriptionHide");
    },
  },
};
</script>
